<div class="div-box-margin, min-width-r" fxLayout="column" fxLayoutAlign="center center">
  <div class="word-break">{{(units == 1 ? RealValue : transVal(RealValue))| number : '1.0-'+MaxNumsAfterDot}}</div>
  <div fxLayout="column">
    <div class="aro-label">{{Title}}</div>
    <div class="aro-label-clickable" (click)="changeUnitsClick()">{{unitsText}}</div>
  </div>
</div>